import { Stack, useMediaQuery } from "@mui/material";
import founderConstants from "../../data/about/founder.json";
import { baseurl } from "../../config";
import React from 'react';
import {
    AppBar,
    Box,
    Button,
    Container,
    Divider,
    IconButton,
    Link,
    List,
    ListItem,
    ListItemText,
    Paper,
    Toolbar,
    Typography,
    useTheme,
} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

type Props = {};

const Admission = (props: Props) => {
    const isSmallScreen = useMediaQuery("(max-width:650px)");
    return (
        <Stack direction="column" spacing={2}>
            <Stack direction="column" spacing={2} width="100%">
                <Container sx={{ py: 4, flex: 1 }}>
                    <Paper elevation={0} sx={{ p: 4, maxWidth: "1000px", mx: "auto" }}>
                        <Typography variant="h4" component="h2" gutterBottom sx={{ color: "#333", mb: 3 }}>
                            Admission Procedure for Academic Year 2027-2028
                        </Typography>

                        <Typography variant="h6" component="h3" sx={{ color: "#0066cc", mb: 2 }}>
                            Admission Procedure for Academic Year 2027-2028
                        </Typography>

                        <Typography paragraph>Parents are advised to read the instructions carefully:</Typography>

                        <Typography paragraph>
                            St. Xaviers School is run and managed by The Poona Catholic Educational Association (Pvt) Ltd and is Private Unaided self-finance, Christian Minority institution according to the Article 30(1) of the Constitution of India. RTE and any kind of reservation is not applicable for the school.
                        </Typography>

                        <Typography paragraph>Admission process for the academic session 2027-2028 is as follows:</Typography>

                        <List sx={{ pl: 4 }}>
                            <ListItem sx={{ display: "list-item", listStyleType: "decimal", pl: 0 }}>
                                <ListItemText
                                    primary={
                                        <Typography>
                                            Login to{" "}
                                            <Link href="http://www.stxavierspune.edu.in" target="_blank">
                                                www.stxavierspune.edu.in
                                            </Link>
                                            . Fill the online admission form, Student details should be filled exactly as per AADHAAR CARD accurately. Admission forms are available online only.
                                        </Typography>
                                    }
                                />
                            </ListItem>
                            <ListItem sx={{ display: "list-item", listStyleType: "decimal", pl: 0 }}>
                                <ListItemText primary="Complete the process online by making payment of Rs.1000/- for the online admission form, which is non-refundable." />
                            </ListItem>
                            <ListItem sx={{ display: "list-item", listStyleType: "decimal", pl: 0 }}>
                                <ListItemText primary="Physical Verification of Documents in the presence of parents & candidate." />
                                <Typography variant="body1" sx={{ mt: 2, mb: 1 }}>
                                    Documents to be submitted:
                                </Typography>

                                <List>
                                    <ListItem sx={{ display: "list-item", listStyleType: "disc", pl: 0, py: 0.5 }}>
                                        <ListItemText primary="Nursery to UKG: Attested copy of your child's birth certificate." />
                                    </ListItem>
                                    <ListItem sx={{ display: "list-item", listStyleType: "disc", pl: 0, py: 0.5 }}>
                                        <ListItemText primary="Recent Two passport size photographs of the child." />
                                    </ListItem>
                                    <ListItem sx={{ display: "list-item", listStyleType: "disc", pl: 0, py: 0.5 }}>
                                        <ListItemText primary="Doctor certificate for proof of good health and detail summary of ongoing illnesses if any from MD or MBBS Doctor. Aadhar Card of the child and parents (compulsory), Residence Proof, Caste Certificate (if applicable), and the Report Card of previous attended school (for LKG & UKG)." />
                                    </ListItem>
                                    <ListItem sx={{ display: "list-item", listStyleType: "disc", pl: 0, py: 0.5 }}>
                                        <ListItemText primary="All original documents must be produced at the time of verification. Aadhar Card which is mandatory, and if it is not made, provide an assurance letter to the school informing that the same will be made available at the earliest." />
                                    </ListItem>
                                    <ListItem sx={{ display: "list-item", listStyleType: "disc", pl: 0, py: 0.5 }}>
                                        <ListItemText
                                            primary={
                                                <>
                                                    Children belonging to Christianity:
                                                    <List sx={{ pl: 4, mt: 1 }}>
                                                        <ListItem sx={{ display: "list-item", listStyleType: "circle", pl: 0, py: 0.5 }}>
                                                            <ListItemText
                                                                primary={
                                                                    <>
                                                                        Roman Catholic Community:
                                                                        <List sx={{ pl: 4, mt: 1 }}>
                                                                            <ListItem sx={{ display: "list-item", listStyleType: "square", pl: 0, py: 0.5 }}>
                                                                                <ListItemText primary="Parish Priest's Letter" />
                                                                            </ListItem>
                                                                            <ListItem sx={{ display: "list-item", listStyleType: "square", pl: 0, py: 0.5 }}>
                                                                                <ListItemText primary="Baptismal Certificate" />
                                                                            </ListItem>
                                                                        </List>
                                                                    </>
                                                                }
                                                            />
                                                        </ListItem>
                                                        <ListItem sx={{ display: "list-item", listStyleType: "circle", pl: 0, py: 0.5 }}>
                                                            <ListItemText
                                                                primary={
                                                                    <>
                                                                        Christian Communities:
                                                                        <List sx={{ pl: 4, mt: 1 }}>
                                                                            <ListItem sx={{ display: "list-item", listStyleType: "square", pl: 0, py: 0.5 }}>
                                                                                <ListItemText primary="Father's School Leaving Certificate" />
                                                                            </ListItem>
                                                                            <ListItem sx={{ display: "list-item", listStyleType: "square", pl: 0, py: 0.5 }}>
                                                                                <ListItemText primary="Letter of the Pastor" />
                                                                            </ListItem>
                                                                            <ListItem sx={{ display: "list-item", listStyleType: "square", pl: 0, py: 0.5 }}>
                                                                                <ListItemText primary="Baptismal Certificate" />
                                                                            </ListItem>
                                                                        </List>
                                                                    </>
                                                                }
                                                            />
                                                        </ListItem>
                                                    </List>
                                                </>
                                            }
                                        />
                                    </ListItem>
                                </List>
                            </ListItem>
                            <ListItem sx={{ display: "list-item", listStyleType: "decimal", pl: 0 }}>
                                <ListItemText primary="Admission status will be communicated through SMS after the verification. Continuously check your online
                            portal for status. " />
                            </ListItem>
                            {/* <ListItem sx={{ display: "list-item", listStyleType: "decimal", pl: 0 }}>
                                <ListItemText primary="Once verification is complete kindly make payment of admission fees for nursery to UKG.
                            STD Rs.54,450 through Online/Demand Draft within 7 working days." />
                            </ListItem> */}

                        </List>



                        <Typography paragraph sx={{ mt: 2 }}>

                        </Typography>

                        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 3, mb: 1 }}>
                            Note:
                        </Typography>

                        <Typography paragraph>
                            Once the form & verification process is complete the selected candidate will receive an SMS for payment of
                            admission fee. Parents are requested not to visit the school or call the school for any updates regarding
                            forms and admission.
                        </Typography>

                        <Typography paragraph>
                            It is mandatory that both parents must come along with the child for verification of documents. Parents are
                            requested to co-operate with administrative staff for smooth admission process due to large number of
                            applications. Admission is granted at the discretion of the committee, which will be final.
                        </Typography>

                        <Typography variant="h6" component="h3" sx={{ color: "#0066cc", mt: 4, mb: 2 }}>
                            Admission:
                        </Typography>

                        <List component="ol">
                            <ListItem sx={{ display: "list-item", listStyleType: "decimal", pl: 0, py: 0.5 }}>
                                <ListItemText primary="Application for admission should be made only online through the admission portal, no forms shall be available at the school." />
                            </ListItem>
                            <ListItem sx={{ display: "list-item", listStyleType: "decimal", pl: 0, py: 0.5 }}>
                                <ListItemText primary="For Indian student: A transfer Certificate from a recognized school will be required when admission is granted to classes 2 and above. For foreign student: If a pupil has come from a different State, the Transfer Certificate must be countersigned by the appropriate authority concerned. Only Transfer Certificate from a recognized school is accepted. If a student has come from a country other than India, the Transfer Certificate must be countersigned by the competent officer of the Indian Embassy/Consulate in that country concerned." />
                            </ListItem>
                            <ListItem sx={{ display: "list-item", listStyleType: "decimal", pl: 0, py: 0.5 }}>
                                <ListItemText primary="Please log on to www.stxavierspune.edu.in and follow the instructions online." />
                            </ListItem>
                            <ListItem sx={{ display: "list-item", listStyleType: "decimal", pl: 0, py: 0.5 }}>
                                <ListItemText primary="No admission will be considered until all the requirements are fully met." />
                            </ListItem>
                            <ListItem sx={{ display: "list-item", listStyleType: "decimal", pl: 0, py: 0.5 }}>
                                <ListItemText primary="Parents/Guardians must give an undertaking, that they will abide by the rules and regulations of the school as made from time to time." />
                            </ListItem>
                            <ListItem sx={{ display: "list-item", listStyleType: "decimal", pl: 0, py: 0.5 }}>
                                <ListItemText primary="The documents should be verified and submitted as per the Admission Notice. A transfer Certificate from a recognized school will be required when admission is granted to classes 2 and above." />
                            </ListItem>
                            <ListItem sx={{ display: "list-item", listStyleType: "decimal", pl: 0, py: 0.5 }}>
                                <ListItemText primary="If a pupil has come from a different State, the Transfer Certificate must be countersigned by the appropriate authority concerned." />
                            </ListItem>
                            <ListItem sx={{ display: "list-item", listStyleType: "decimal", pl: 0, py: 0.5 }}>
                                <ListItemText primary="Only Transfer Certificate from a recognized school is accepted. If a student has come from a country other than India, the Transfer Certificate must be countersigned by the appropriate officer of the Indian Embassy/Consulate in that country concerned." />
                            </ListItem>
                        </List>


                        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 3, mb: 1 }}>
                            Note:
                        </Typography>

                        <List>
                            <ListItem sx={{ display: "list-item", listStyleType: "disc", pl: 0, py: 0.5 }}>
                                <ListItemText primary="The Management/Principal reserves right to refuse admission without assigning any reason." />
                            </ListItem>
                            <ListItem sx={{ display: "list-item", listStyleType: "disc", pl: 0, py: 0.5 }}>
                                <ListItemText primary="All new students who seek admission in the school from Nursery to UKG require attested Birth-Certificate, Doctor's fitness Certificate and two stamp size photographs." />
                            </ListItem>
                            <ListItem sx={{ display: "list-item", listStyleType: "disc", pl: 0, py: 0.5 }}>
                                <ListItemText primary="A new student joining from his home or a private School must produce an official Birth Certificate. (Applicable only for Classes Nursery to UKG)." />
                            </ListItem>
                            <ListItem sx={{ display: "list-item", listStyleType: "disc", pl: 0, py: 0.5 }}>
                                <ListItemText primary="Admissions are done on &quot;FIRST COME FIRST SERVE&quot; basis. Online necessary is must for all admission." />
                            </ListItem>
                        </List>

                        <Typography variant="h6" component="h3" sx={{ color: "#0066cc", mt: 4, mb: 2 }}>
                            Age criteria for academic year 2027-2028:
                        </Typography>

                        <Box sx={{ overflowX: "auto", mb: 3 }}>
                            <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #ddd" }}>
                                <thead>
                                    <tr style={{ backgroundColor: "#f9f9f9" }}>
                                        <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Class</th>
                                        <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Age Group</th>
                                        <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                                            Minimum Age as on 31 MARCH 2027
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>Nursery</td>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>3+ Years</td>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>3+ Years</td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>LKG</td>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>4+ Years</td>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>4+ Years</td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>UKG</td>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>5+ Years</td>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>5+ Years</td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>I STD</td>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>6+ Years</td>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>6+ Years</td>
                                    </tr>
                                </tbody>
                            </table>
                        </Box>

                        <Typography variant="h6" component="h3" sx={{ color: "#0066cc", mt: 4, mb: 2 }}>
                            Submission of Admission Form:
                        </Typography>


                        <List sx={{ pl: 0 }}>
                            <ListItem sx={{ display: "list-item", listStyleType: "decimal", pl: 4, py: 0.5 }}>
                                <ListItemText primary="It is MANDATORY for Parents to fill and submit online admission form with the payment of Rs. 950/- (If you
                            face any problem in filling the online admission form, our technical team will be there to guide you. kindly
                            call on 8149830102 In office hours (08:30 AM TO 3:30 PM and Monday to Friday Only). Application fee is
                            non-refundable. JUST SUBMISSION OF FORM DOES NOT GUARANTEE ADMISSION. Admission will be granted only against
                            vacancy in respective class." />
                            </ListItem>
                            <ListItem sx={{ display: "list-item", listStyleType: "decimal", pl: 4, py: 0.5 }}>
                                <ListItemText primary="Verification of documents with parent along with candidate: The school selects the student and communicates via SMS and call for Verification of Documents." />
                            </ListItem>
                            <ListItem sx={{ display: "list-item", listStyleType: "decimal", pl: 4, py: 0.5 }}>
                                {/* before the - 'The admission fees does not' Payment of admission fees: Once the admission is granted, make payment of Rs.54,450/- (Rupees Fifty-four thousand and four hundred and fifty only) for Nursery to UKG by making a Demand Draft in Favor of &quot;St. Xaviers Pre-Primary School&quot; payable at Pune and submit at the school fee counter. */}
                                <ListItemText primary="The admission fees does not include uniform charges, textbooks and transportation fees. Kindly take note Bank cheque or cash will not be accepted. Admission fee is non-refundable. If the candidate fails to make payment of admission fee within 7 working days, then seat will go to next waiting candidates." />
                            </ListItem>
                            <ListItem sx={{ display: "list-item", listStyleType: "decimal", pl: 4, py: 0.5 }}>
                                <ListItemText primary="Once the admission fee is credited to school account, confirmation of admission will be intimated through SMS/email. The principal decision regarding the admission of a student will be final. No recommendations, School management has not authorized any agents for school admission. Please note that, in case you are not interested in seeking admission at St. Xaviers School and you wish to withdraw your child's name then you need to inform us within 2 days on receiving admission confirmation." />
                            </ListItem>
                        </List>

                        <Typography variant="h6" component="h3" sx={{ color: "#0066cc", mt: 4, mb: 2 }}>
                            Declaration:
                        </Typography>

                        <Typography paragraph>
                            I the user of this portal have read the above procedure, terms and conditions and the privacy policy, I
                            declare by clicking "I agree" and state that I have understood and agree to the terms of the portal.
                        </Typography>

                        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 3, mb: 1 }}>
                            Note:
                        </Typography>

                        <Typography paragraph>
                            School Fee Structure is approved by the School Management in consultation as per the Maharashtra Educational
                            Institutions (Regulation of Fee) Act, 2011 for Academic Year 2027-28 shall be provided to the parents at
                            the time of admission. The school being a Minority School, the Management's decision regarding fees will be
                            final and binding on prospective parents.
                        </Typography>
                    </Paper>
                </Container>
            </Stack>
        </Stack>
    );
};

export default Admission;
